import React from "react";
import { toast } from "sonner";
import { Calendar, MapPin, Trophy, Users } from "lucide-react";
import useFetch from "@/lib/useFetch";
import api from "@/lib/api";
import { PageHeader, Footer } from "@/components/common/Page";
import Loader from "@/components/common/Loader";
import { fmtDate } from "@/lib/communities";
import { Button } from "@/components/ui/button";

export default function Events() {
    const { data: events } = useFetch("/events");
    const { data: communities } = useFetch("/communities");
    if (!events || !communities) return <Loader />;
    const nameFor = (k) => communities.find((c) => c.key === k)?.name || k;

    const register = async (e) => {
        try {
            const { data } = await api.post(`/events/${e.id}/register`);
            toast.success(data.message, { description: e.title });
        } catch {
            toast.error("Could not register");
        }
    };

    return (
        <div data-testid="player-events">
            <PageHeader title="Events" subtitle="Raids, tournaments, purges and more across the network." />
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {events.map((e) => (
                    <div key={e.id} data-testid={`event-${e.id}`} className="tactical-card rounded-lg p-5">
                        <div className="flex items-center justify-between">
                            <span className="rounded-sm border border-hazard/40 bg-hazard/10 px-2 py-0.5 label-mono text-hazard">{e.type}</span>
                            <span className="label-mono text-muted-foreground">{nameFor(e.community_key)}</span>
                        </div>
                        <h3 className="font-heading text-xl font-bold uppercase text-foreground mt-3">{e.title}</h3>
                        <p className="text-sm text-muted-foreground mt-1">{e.description}</p>
                        <div className="grid grid-cols-2 gap-2 mt-4 text-sm">
                            <Row icon={Calendar} text={fmtDate(e.date)} />
                            <Row icon={MapPin} text={e.location || "—"} />
                            <Row icon={Trophy} text={e.rewards || "—"} />
                            <Row icon={Users} text={`${e.registrations}/${e.registration_limit || "∞"} registered`} />
                        </div>
                        <Button data-testid={`register-event-${e.id}`} className="mt-4 w-full font-heading uppercase bg-hazard text-black hover:bg-hazard/90"
                            onClick={() => register(e)}>
                            Register
                        </Button>
                    </div>
                ))}
            </div>
            <Footer />
        </div>
    );
}

function Row({ icon: Icon, text }) {
    return (
        <div className="flex items-center gap-2 text-muted-foreground">
            <Icon size={14} className="text-hazard shrink-0" /> <span className="truncate text-foreground">{text}</span>
        </div>
    );
}
